import { Job, Readable } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect } from 'react'
import { hydrate } from 'react-dom'
import Recommendations from '../molecules/Recommendations'

interface IProps {
  readable: Readable
  recommendations: Job[]
  className?: string
}

const ArticleContentWithRecommendations = ({
  readable,
  recommendations,
  className = '',
}: IProps) => {
  const { t } = useTranslation('common')

  let url: string
  let header: string

  const loadImg = () => {
    document.querySelectorAll('img[data-src]').forEach((img) => {
      const imgUrl = img.getAttribute('data-src')
      const newImg = new Image()
      newImg.onload = function () {
        // @ts-ignore
        img.src = imgUrl
      }
      // @ts-ignore
      newImg.src = imgUrl
    })
  }

  if (readable.mainTag) {
    url = `/companies/jobs/s/skills,${readable.mainTag}?utm_source=rec`
    header = t('show_popular_offers_for', { for: readable.mainTag })
  } else if (readable.roles && readable.roles.length === 1) {
    const role = readable.roles[0].key
    const translatedRole = t(`common:role_${role}`)
    url = `/companies/jobs/s/role,${role}?utm_source=rec`
    header = t('show_popular_offers_for', { for: translatedRole })
  } else {
    url = `/companies/jobs?utm_source=rec`
    header = t('show_popular_offers')
  }

  useEffect(() => {
    setTimeout(loadImg, 500)
  }, [])

  useEffect(() => {
    if (!recommendations || recommendations.length === 0) return

    const h2 = document.querySelectorAll('.content h2')
    if (h2 && h2[2] && !document.getElementById('target')) {
      h2[2].insertAdjacentHTML('beforebegin', '<div id="target" />')

      hydrate(
        <Recommendations
          recommendations={recommendations}
          header={header}
          url={url}
        />,
        document.querySelector('#target')
      )
    }
  }, [recommendations])

  return (
    <div
      className={`content text-base leading-7 md:text-2xl md:leading-9 order-1 md:order-2 ${className}`}
      dangerouslySetInnerHTML={{ __html: readable.content as string }}
    />
  )
}

export default ArticleContentWithRecommendations
